import { ga } from '../../engine/ga-sidecar'
import { settings } from '../../engine/settings-sidecar'
import { websockets } from '../../engine/websockets-sidecar'
import { queryString } from '../../lib/queryString-sidecar'
import { common } from '../../main/common-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { uiFps } from '../../ui/uiFps-sidecar'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import { chessAiRando } from './ai/chessAiRando-sidecar'
import { chessBoard } from './chessBoard-sidecar'
import { chessColors } from './chessColors-sidecar'
import { chessGameManager } from './chessGameManager-sidecar'
import { chessGameRules } from './chessGameRules-sidecar'
import { chessKeyboard } from './chessKeyboard-sidecar'
import { chessLayers } from './chessLayers-sidecar'
import { chessParticlesData } from './chessParticlesData-sidecar'
import { EChessTeam } from './chessPieces'
import { chessPiecesData } from './chessPiecesData-sidecar'
import { chessTestParams } from './chessTestParams-sidecar'
import { chessTilemap } from './chessTilemap-sidecar'
import { EChessClientRequest } from './messages/chessMessageClientRequest'
import { chessMessageClientRequestResponse } from './messages/chessMessageClientRequestResponse-sidecar'
import { chessMessages } from './messages/chessMessages-sidecar'
import { chessWebsockets } from './messages/chessWebsockets-sidecar'
import { chessSounds } from './sound/chessSounds-sidecar'
import { chessShaderTest } from './tests/chessShaderTest-sidecar'
import { chessUiSetupAI } from './ui/chessUiSetupAI-sidecar'

export function create() {
  ga.init('chess')

  spritesUtil.setDefaultScale(2)
  settings.create('chess:settings', 1)

  const soundsJson = common.getPhaserScene().cache.json.get('audioSprite2')
  chessSounds.load(soundsJson, '/assets/music')

  let ps = common.getPhaserScene()
  ps.cameras.main.setBackgroundColor(chessColors.background) //0x666666)

  chessShaderTest.installShaders()

  chessPiecesData.registerAll()
  chessParticlesData.registerAll()
  chessMessages.registerAll()

  // const soundsJson = common.getPhaserScene().cache.json.get('audioSprite2')
  // voyageSounds.load(soundsJson, '/assets/music')

  chessLayers.create()

  chessBoard.create()
  chessTilemap.create()

  // buttons2.setDefaultFrames(buttons2.defaultFramesBasic)
  // buttons2.setDefaultFont(echoFonts.getData().font6)

  uiFps.create(chessLayers.getLayers().uiGame)
  uiFps.setOpen(true)
  clickEater.create()
  // voyageKeyboard.create()

  // voyageBackground.create()

  chessKeyboard.create()

  let tm = chessTestParams.loadTestMode()
  chessWebsockets.create()

  // chessFontTest.create()
  chessShaderTest.create()

  // voyageGameManager.goLoading()

  if (tm === 'game') {
    let tryChan = queryString.getByName('chan') || ''
    if (!chessTestParams.multiplayerAutoJoin || !tryChan) {
      websockets.setSingleplayer(true)
      chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
        command: EChessClientRequest.SitWhite,
        multiId: chessWebsockets.getMultiId(),
      })
      chessUiSetupAI.setOpen(true)

      // chessAiRando.create(EChessTeam.White)
      // chessAiRando.create(EChessTeam.Black)
    } else {
    }
    chessGameManager.goGame()
  } else if (tm === 'ai') {
    websockets.setSingleplayer(true)

    chessMessageClientRequestResponse.sendMessageAndImmediatelyExecute({
      command: EChessClientRequest.SitWhite,
      multiId: chessWebsockets.getMultiId(),
    })

    chessAiRando.create(EChessTeam.Black)

    chessGameManager.goGame()
  } else if (tm === 'ai2') {
    chessGameRules.setSuperTest()
    websockets.setSingleplayer(true)
    chessAiRando.create(EChessTeam.White)
    chessAiRando.create(EChessTeam.Black)

    chessGameManager.goGame()
  } else {
    chessGameManager.goMenuMain()
  }
}
